export default __webpack_public_path__ + "static/media/jamon.b0e0d786.png";